export const PENDING_STATUS = 'pending';
export const UPLOADING_STATUS = 'uploading';
export const UPLOADED_STATUS = 'uploaded';
export const SENT_STATUS = 'sent';
export const READ_STATUS = 'read';
export const TOPIC_TYPE = 'topic';
